import {Injectable} from '@angular/core';
import {Location} from '@angular/common';
import {BehaviorSubject, Subject} from 'rxjs';
import {AuthService} from './auth.service';

export interface IItemInfo {
    id: string | any;
    data?: any;
    isItemSelected: boolean | any;
    debarmentId?: string | any;
    complaintId?: number | any;
    legacyDebarmentId?: string | any;
}

@Injectable()

export class ItemService {


    public info = new BehaviorSubject<IItemInfo>(
        {
            id: undefined,
            data: undefined,
            isItemSelected: false,
            debarmentId: undefined,
            complaintId: undefined,
            legacyDebarmentId: undefined
        }
    );

    constructor(private location: Location,
                private authService: AuthService) {

    }

    public reset() {
        this.info.next({
            id: undefined,
            isItemSelected: undefined,
        });
    }

    isAnItemSelected() {
        const location = this.authService.extractPath(this.location.path());
        const pathParts = location.split('/');
        if (pathParts[2] === 'system-configuration') {
            return true;
        } else {
            return pathParts.length > 4;
        }
    }

    extractSelectedItemId() {
        const pathParts = this.authService.extractPath(this.location.path()).split('/');
        return pathParts[3];
    }

    extractDebarmentId() {
        const pathParts = this.authService.extractPath(this.location.path()).split('/');
        return pathParts[4];
    }

    extractComplaintId() {
        const pathParts = this.authService.extractPath(this.location.path()).split('/');
        return pathParts[4];
    }

    extractLegacyDebarmentId() {
        const pathParts = this.authService.extractPath(this.location.path()).split('/');
        return pathParts[3];
    }

    detectItemSelection() {
        if (this.isAnItemSelected()) {
            this.info.next({
                id: this.extractSelectedItemId(),
                isItemSelected: true,
                debarmentId: this.extractDebarmentId(),
                complaintId: this.extractComplaintId(),
                legacyDebarmentId: this.extractLegacyDebarmentId(),
            });
        }
    }
}
